import {Component, HostBinding, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-fullscreen-menu',
  templateUrl: './fullscreen-menu.component.html',
})
export class FullscreenMenuComponent implements OnInit {
  @HostBinding('class.header-menu-item') fullscreen = true;
  isFullscreen: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  exitHandler() {
    this.isFullscreen.next(!(!document['fullscreenElement']
      && !document['webkitIsFullScreen']
      && !document['mozFullScreen']
      && !document['msFullscreenElement']));
  }

  ngOnInit() {
    document.addEventListener('fullscreenchange', () => this.exitHandler());
    document.addEventListener('webkitfullscreenchange', () => this.exitHandler());
    document.addEventListener('mozfullscreenchange', () => this.exitHandler());
    document.addEventListener('MSFullscreenChange', () => this.exitHandler());
  }

  toggleFullScreen() {
    const isFullscreen = document['webkitIsFullScreen'] || document['mozFullScreen'] || false;
    let elem;
    let methodToBeInvoked;
    if (isFullscreen) {
      elem = document;
      methodToBeInvoked = document['cancelFullScreen'] ||
        document['webkitCancelFullScreen'] ||
        document['mozCancelFullScreen'] ||
        false;
    } else {
      elem = document.documentElement;
      methodToBeInvoked = elem.requestFullscreen ||
        elem['webkitRequestFullScreen'] ||
        elem['mozRequestFullscreen'] ||
        elem['msRequestFullscreen'] ||
        false;
    }
    if (methodToBeInvoked) {
      methodToBeInvoked.call(elem);
    }
  }
}
